import "core-js/modules/es.array.push.js";
import { api } from '@/server';
import { useRouter } from 'vue-router';
import { modal } from '@/share/components';
export const useNewProjKpiMonitor = () => {
  const {
    runAsync: getProjMonitorDraft
  } = fetchApi(api.kpi.projMonitor.getDraft);
  const {
    runAsync: createProjMonitor
  } = fetchApi(api.kpi.projMonitor.create);
  const {
    runAsync: removeProjMonitor
  } = fetchApi(api.kpi.projMonitor.remove);
  const router = useRouter();
  const newProjKpiMonitor = async projId => {
    if (!projId) {
      modal.message.warning('没有选择项目绩效指标表或获取指标表ID失败，请重新打开');
      return false;
    }
    const {
      error,
      id: oldPmId
    } = await getProjMonitorDraft({
      projId
    });
    if (error) return false;
    if (oldPmId) {
      const confirm = await modal.confirm('新建监控表', '存在之前未完成的监控表，是否继续编辑？', {
        okText: '继续编辑',
        cancelText: '新建'
      });
      if (confirm) {
        // 继续编辑之前的监控表
        await router.push({
          path: `/kpi/proj-kpi/monitor/monitor-detail/${oldPmId}`,
          query: {
            m: 'edit'
          }
        });
        return true;
      }
      // 新建监控表, 删除之前的草稿监控表
      const {
        error
      } = await removeProjMonitor({
        id: oldPmId
      });
      if (error) {
        modal.notification.error('删除之前的监控表草稿失败', '新建监控表').catch();
        return false;
      }
    }
    // 新建监控表
    const {
      error: newError,
      id: newId
    } = await createProjMonitor({
      projId
    });
    if (newError) {
      modal.notification.error('新建监控表失败:' + newError, '新建监控表').catch();
      return false;
    }
    await router.push({
      path: `/kpi/proj-kpi/monitor/monitor-detail/${newId}`,
      query: {
        m: 'edit'
      }
    });
    return true;
  };
  return {
    newProjKpiMonitor
  };
};